exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.panel[data-v-8e1480dc] {\n  height: auto !important;\n}\n.ticketGraph[data-v-8e1480dc] {\n  width: 59px;\n  height: 110px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-8e1480dc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/FeedcardOccupancyReport.vue
// module id = 2431
// module chunks = 0